module.exports = __webpack_public_path__ + "static/media/643952616_26511148778489828_8323879253633527544_n.c9900ffe.jpg";